import { createHashParam, useNextHashQueryParams, useNextQueryParams } from './useNextQueryParams';
import type { LocaleItem } from '@icommerce/i18n';
import { getProductIdForLocale, getQueryArtNr } from '@libs/product.helper';
import type { ProductFragmentEnhanced } from '@models/enhanced-fragments';
import { IGUS_REWRITE } from '@libs/redirect.helper';
import type { LanguageAlternate } from '@models/data';

export interface LocaleSelectionProps {
  languageAlternates: ReadonlyArray<LanguageAlternate>;
  currentProduct?: ProductFragmentEnhanced;
}

export const useLocaleSelection = ({ languageAlternates, currentProduct }: LocaleSelectionProps) => {
  const query = useNextQueryParams();
  const hashParams = useNextHashQueryParams();
  const urlParams = createHashParam(hashParams).toString();

  const getCurrentUrlForTargetLocale = (language: LocaleItem) => {
    const alternate = languageAlternates.find(languageAlternate => languageAlternate.hrefLang === language.code);
    const urlFragmentParams = Object.keys(urlParams).length ? `#${urlParams}` : '';

    const searchParams = () => {
      if (query.artnr && currentProduct) {
        return `?artnr=${getProductIdForLocale(currentProduct, language.code)}${urlFragmentParams}`;
      }
      if (query.artnr) {
        return `?artnr=${getQueryArtNr(query)}${urlFragmentParams}`;
      }
      return urlFragmentParams;
    };

    return alternate ? `${alternate.href}${searchParams()}` : IGUS_REWRITE('', language.code);
  };

  return { getCurrentUrlForTargetLocale };
};
